// removed by extract-text-webpack-plugin
module.exports = {"CustomiseDownload":"_19YRC78cwb5XL1kigtW3MC","PackPopupSettings__field":"_36yr94BIokJce4rfsSqDyi","PackPopupSettings__field-select":"_1Iwu0qlT42jZuXbzQE59Vl","PackPopupSettings__field-checkbox":"_2DT18lcdvrLewGliEhQ5Vi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PackDownloadPopup/PackDownloadPopup.scss
// module id = 2722
// module chunks = 0